const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);
const DEFAULT_FUNCTIONS_REGION = "europe-west2";

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const getConfiguredFunctionBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_FUNCTION_BASE_URL?.trim();

  if (configuredBaseUrl) {
    return trimTrailingSlash(configuredBaseUrl);
  }

  const useEmulators =
    process.env.REACT_APP_FIREBASE_USE_EMULATORS === "true" &&
    LOCAL_HOSTNAMES.has(window.location.hostname);

  if (useEmulators) {
    return "/functions-api";
  }

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID?.trim();

  if (projectId) {
    return `https://${DEFAULT_FUNCTIONS_REGION}-${projectId}.cloudfunctions.net`;
  }

  return "";
};

export const buildFunctionUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const baseUrl = getConfiguredFunctionBaseUrl();

  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
};
